// extracted by mini-css-extract-plugin
export default {"container":"AddendumEditor_container__AtDKo"};